import {isAdmin, isPublisherUserOrPublisherAdmin, isValidPublisherId, getPublisherIdList} from '../auth';

/**
 * Pure function that decides which render path Home.render() should take.
 * Extracted so render() calls this directly and the unit test exercises the
 * same code — no test may re-implement the condition (UN-54784).
 *
 * Returns one of:
 *   'NO_ALLOWED_PUBLISHER'     — user has no publishers at all
 *   'SELECT_ALLOWED_PUBLISHER' — user has publishers but current is unusable
 *   'NORMAL'                   — current publisher is valid and in the allowed list,
 *                                or the user is not a publisher-role user
 *
 * Undertone internals carry PUBLISHER_ADMIN (role 4) alongside userType WORKFLOW while having no
 * publisher claims, so role alone cannot decide this — without the isAdmin check they render the
 * no-allowed-publisher message on a /internal/:id deep link (UN-54784 Flow B).
 */
export const getPublisherRenderPath = (currentPublisherId, allowedPublisherId, role, userType) => {
    if (isAdmin({role, userType})) {
        return 'NORMAL';
    }

    const allowedList = getPublisherIdList(allowedPublisherId);
    const isCurrentUsable =
        isValidPublisherId(currentPublisherId) &&
        allowedList.includes(String(currentPublisherId));

    if (!isCurrentUsable && isPublisherUserOrPublisherAdmin({role})) {
        return allowedList.length === 0 ? 'NO_ALLOWED_PUBLISHER' : 'SELECT_ALLOWED_PUBLISHER';
    }
    return 'NORMAL';
};
